var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-sub-title"},[_c('div',{staticClass:"inner"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('div',[_vm._v(_vm._s(_vm.enTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }